import { render } from "./HomeView.vue?vue&type=template&id=2dccbe74"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=2dccbe74&lang=css"

import exportComponent from "C:\\Users\\reddy\\Desktop\\cred games\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__